<template>
  <div class="tableWithPerPageSelection">
    <div class="entete mgb-20px">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ getTitle }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right section-details">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      @click="$router.push({ name: 'l.logistique.demande-restriction',
                      params: { yearWeek: getAnneeSemaineOfSearch } })">
                {{ $t('listeDemande.actions.restrictions')}}
              </button>
              <button class="button is-addOrEdit"
                      @click="$router.push({ name: 'l.logistique.demande-disponible',
                      params: { yearWeek: getAnneeSemaineOfSearch } })">
                {{ $t('listeDemande.actions.faceDispo')}}
              </button>
              <b-field>
                <dropdownButton
                  type="is-addOrEdit"
                  :actions="actionSecondary"
                  @click="ouverturePopUpGeneration">
                    {{ $t('listeDemande.actions.generer')}}
                </dropdownButton>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :error="error"
                         :title="'addEditCivilite.error.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="tab mgh-0">
      <ul>
        <router-link :to="{ name: 'l.logistique.demande-auto'}"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permDemande.lecture)}">
          <li :class="{'is-active': $router.currentRoute.name === 'l.logistique.demande-auto'
            || $router.currentRoute.name === 'l.logistique.demande-auto'}">
            {{$t('listeDemande.demandesAffichages')}}
          </li>
        </router-link>
        <router-link :to="{ name: 'l.logistique.demande-manuel'}"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permDemande.lecture)}">
          <li :class="{'is-active': $router.currentRoute.name
            === 'l.logistique.demande-manuel'}">
            {{$t('listeDemande.demandesLogistiques')}}
          </li>
        </router-link>
      </ul>
    </div>
    <router-view @refreshList="loadDemande" @changeDateSelect="changeDateSelect">
    </router-view>
    <b-modal v-model="popUpGeneration" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('listeDemande.popUpPreventionGeneration.titlePopUp')"
        :cancel="$t('general.button.return')"
        :validate="$t('listeDemande.popUpPreventionGeneration.generer')"
        @no="popUpGeneration = false"
        :questions="questions"
        @validateQuestions="applyPrevChoicesSync">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpGenerationAuto" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('listeDemande.popUpPreventionGenerationAuto.titlePopUp')"
        :messFooter="getUser(user.id)
        ? $t('listeDemande.popUpPreventionGenerationAuto.secondTitle',
        { mail: getUser(user.id) })
        : $t('listeDemande.popUpPreventionGenerationAuto.secondTitleNoMail')"
        :cancel="$t('general.button.return')"
        :validate="$t('listeDemande.popUpPreventionGenerationAuto.generer')"
        :questions="questions"
        @no="popUpGenerationAuto = false"
        @validateQuestions="applyPrevChoicesAsync">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import breadcrumb from '@/components/general/breadcrumb';
import dropdownButton from '@/components/general/button/dropdownButton';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import formatDate from '@/services/general/formatDate';
import formatDatePourBack from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import { DEMANDE } from '@/configuration/logistique/permissionsLogistiqueConf';
import { generation } from '@/api/logistique/tourneeFaceSemaine/index';
import { SET_DATE_SELECT } from '@/store/modules/logistique/demande-mutation-type';
import popUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import validationGenerationTfs from '@/services/logistique/demande/validations/validationGenerationTfs';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Demande = createNamespacedHelpers('demande');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      unsubscribeValue: null,
      popUpGeneration: false,
      permDemande: DEMANDE,
      popUpGenerationAuto: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      questions: [
        {
          key: 0,
          message: 'listeDemande.popUpPreventionGeneration.checkEcrasement',
          value: true,
        },
        {
          key: 1,
          message: 'listeDemande.popUpPreventionGeneration.checkEcrasementInstruction',
          value: true,
        },
      ],
    };
  },
  components: {
    breadcrumb,
    popUpPrevention,
    dropdownButton,
    errorMsgComponent,
  },
  computed: {
    ...Demande.mapGetters({
      dateSelect: 'dateSelect',
      criteresRecherche: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
      site: 'site',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getAnneeSemaineOfSearch() {
      return (getAnneeSemaineFromDate(this.dateSelect));
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('listeDemande.actions.generationAuto'),
          action: () => { this.popUpGenerationAuto = true; },
        },
      ];

      return actions;
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.getTitle, route: '', isActive: true },
      ];
    },
    getTitle() {
      switch (this.$router.currentRoute.name) {
        case 'l.logistique.demande-auto':
          return this.$i18n.t('listeDemande.titleDemandeAff');
        default:
          return this.$i18n.t('listeDemande.titleDemandeManuel');
      }
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateurForce: 'loadParametreUtilisateurForce',
    }),
    ...Demande.mapMutations({
      setDateSelect: SET_DATE_SELECT,
    }),
    ...Demande.mapActions({
      actionLoadDemande: 'loadDemande',
      actionLoadDemandesLogistiques: 'loadDemandesLogistiques',
    }),
    getUser(userId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((user) => {
          return user.id === userId;
        });
      return userFind ? userFind.email : null;
    },
    getDateFormate(date) {
      return formatDate(date);
    },
    changeDateSelect(date) {
      if (!date) return;
      this.setDateSelect(date);
      this.loadDemande();
    },
    ouverturePopUpGeneration() {
      this.popUpGeneration = true;
    },
    async applyPrevChoicesSync(values) {
      let sansEcrasementAffectation = true;
      let sansEcrasementInstructionPose = true;
      if (values !== null && values.length > 0) {
        values.forEach(value => {
          switch (value.key) {
            case 0:
              sansEcrasementAffectation = value.value;
              break;
            case 1:
              sansEcrasementInstructionPose = value.value;
              break;
            default:
              break;
          }
        });
        await this.generationTournee(sansEcrasementAffectation,
          sansEcrasementInstructionPose,
          false);
      }
      this.popUpGeneration = false;
    },
    async applyPrevChoicesAsync(values) {
      let sansEcrasementAffectation = true;
      let sansEcrasementInstructionPose = true;
      if (values !== null && values.length > 0) {
        values.forEach(value => {
          switch (value.key) {
            case 0:
              sansEcrasementAffectation = value.value;
              break;
            case 1:
              sansEcrasementInstructionPose = value.value;
              break;
            default:
              break;
          }
        });
        await this.generationTournee(sansEcrasementAffectation,
          sansEcrasementInstructionPose,
          true);
      }
      this.popUpGenerationAuto = false;
    },
    async generationTournee(sansEcrasementAffectation, sansEcrasementInstructionPose, background) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        await generation({
          anneeSemaine: getAnneeSemaineFromDate(this.dateSelect),
          societeId: this.societeId,
          ecrasementAffectation: !sansEcrasementAffectation,
          ecrasementInstructionPose: !sansEcrasementInstructionPose,
          backgroundJob: background,
          agenceIds: this.agenceActive.map((agence) => agence.agenceId),
        });
        this.popUpGeneration = false;
        loadingComponent.close();
        await this.loadDemande();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationGenerationTfs(e, this.messages);
          this.popUpGeneration = false;
          this.error = true;
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    goFirstPage() {
      if (this.$refs.tableDemande) {
        this.$refs.tableDemande.setPage(1);
      }
      if (this.$refs.tableDemandeAuto) {
        this.$refs.tableDemandeAuto.setPage(1);
      }
    },
    async loadDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const agenceIds = this.agenceActive.map((agence) => agence.agenceId);
        const dateDebut = formatDatePourBack(moment(this.dateSelect).startOf('week').toDate());
        const dateFin = formatDatePourBack(moment(this.dateSelect).endOf('week').toDate());
        if (this.criteresRecherche.reseau && this.criteresRecherche.reseau.length > 0) {
          this.criteresRecherche.produitsIds = this.criteresRecherche.reseau.map(el => el.id);
          delete this.criteresRecherche.reseau;
        }
        const paramsDemandes = {
          query: {
            ...this.criteresRecherche,
            datesPrevisionnelDepart: {
              dateDebut: dateDebut,
              dateFin: dateFin,
            },
            societeId: this.societeId,
            agencesIdProduit: agenceIds,
            auto: this.criteresRecherche.auto,
          },
          limit: NO_PAGINATION,
        };
        await this.actionLoadDemande(paramsDemandes);
        const parametreDemandesLogistiques = {
          query: {
            datePlanification: {
              dateDebut: dateDebut,
              dateFin: dateFin,
            },
            societeId: this.societeId,
            agencesIds: agenceIds,
          },
          limit: NO_PAGINATION,
          orderBy: 'datePlanification',
          ascending: true,
        };
        await this.actionLoadDemandesLogistiques(parametreDemandesLogistiques);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadDemande();
      await this.loadParametreUtilisateurForce(PARAMETRES_KEYS.utilisateur);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.loadDemande, this.goFirstPage);
      this.setInformationPage(this.$t('pageLogistique.demande.listeDemandeAff'));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
};
</script>
